module.exports = __webpack_public_path__ + "img/sy.8e44fa5a.png";